import { Flex } from '@chakra-ui/react';
import { useAuth } from '../../hooks/auth';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';

interface IDefaultPage {
  children?: any;
}

const DefaultPage: React.FC<IDefaultPage> = ({ children }) => {
  return (
    <Flex direction="column" minH="100vh">
      <Header />

      <Flex w="100%" h="100%" mx="auto" flex="1">
        <Sidebar />
        <Flex w="100%" h="100%" px="6" flexDir="column" pt="6">
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DefaultPage;
